const languagesData = [
  { id: 1, name: "Español", level: "Nativo" },
  { id: 2, name: "Inglés", level: "Intermedio" }
];

export default languagesData;